import { authorizedRequests } from "../axios/axios-config";
import api from "../axios/axios-config";

export const getAppointments = async () => {
	try {
		let response = await api.get(
			"appointment/listOfAppointments",

			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const updateAppointments = async (data) => {
	try {
		let response = await authorizedRequests({
			url: "appointment/updateAppointment",
			method: "post",
			data: data,
		});
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};
